// SIGNING CONSTANTS
export const SIGNATURE_CONTAINER_STATUS = {
    unsigned: 'unsigned',
    signedByMetsahake: 'metsahake',
    signed: 'signed',
};
